<template>
  <div class="navbar">
    <!-- <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>

    <breadcrumb class="breadcrumb-container"/>-->
    <!-- <message-dialog :dialog-visible="dialogVisible" :dialog-close="handleClose"/> -->
    <div class>
      <a class="topbar-logo topbar-left">
        <img
          src="@/common/assets/images/login-logo.svg"
          class="icon-logo"
          alt="logo"
        />
        <span class="iconLogo-v-help" />
      </a>
      <a class="topbar-logo-text topbar-left">
        <!-- <img :src="ssTitle" class="image-logo-title" /> -->
        <span>护理质量检查系统</span>
      </a>
      <div class="topbar-left">
        <!-- <span>{{ navStyle }}</span> -->
        <ul v-if="navStyle !== 'nonTopMenu'" class="nav-menu">
          <li
            v-for="menu in navMenus"
            :key="menu.path"
            :class="{ selected: menu.path === selectedMenuItemKey }"
            class="nav-menu-item"
            @click="onNavMenuitemClick(menu.fullPath)"
          >
            <span class="show-ellipsis">{{ menu.name }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="topbar-right">
      <ul class="right-menu">
        <!-- <li>
          <el-select
            v-model="currentHospCode"
            placeholder="请选择院区"
            size="mini"
            class="nms-input"
            style="width: 220px; margin: 0 10px"
            @change="changeHosptal"
          >
            <el-option
              v-for="item in visitHospitalList"
              :key="item.hospitalCode"
              :label="item.hospitalName"
              :value="item.hospitalCode"
            />
            <i slot="suffix" class="el-input__icon el-icon-date" />
          </el-select>
        </li> -->
        <span v-if="VersionInfo" class="version">{{ VersionInfo }}</span>
        <li class="right-menu-item2" @click="toHome">
          <img :src="require('@/common/assets/images/top-home.png')" alt="" />
        </li>
        <li class="right-menu-item">
          <bp-dropdown :align="'bottomRight'">
            <template>
              <div class="login-user-info">
                <svg-icon
                  class-name="international-icon"
                  icon-class="admin_01"
                />
                <span>{{ loginUserInfo ? loginUserInfo.username : '' }}</span>
              </div>
            </template>
            <template slot="popover">
              <div class="login-info-panel">
                <div>
                  <div>
                    <span class="info-title">工号：</span>
                    <span class="info-value">{{
                      loginUserInfo ? loginUserInfo.UserId : ''
                    }}</span>
                    <span class="info-title">姓名：</span>
                    <span class="info-value">{{
                      loginUserInfo ? loginUserInfo.username : ''
                    }}</span>
                  </div>
                  <!-- <div>
                    <span class="info-title">登录时间：</span>
                    <span class="info-value">
                      {{
                        (loginUserInfo && loginUserInfo.loginDate)
                          | dateFormatTo16
                      }}
                    </span>
                  </div> -->
                </div>
                <div>
                  <w-button
                    type="waring"
                    size="small"
                    icon="el-icon-circle-close-outline"
                    class="logout-btn"
                    @click="onLogoutClick"
                    >退出登录</w-button
                  >
                </div>
              </div>
            </template>
          </bp-dropdown>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as pathToRegexp from 'path-to-regexp'
import { urlToList } from '@/common/utils/pathTools'
import Breadcrumb from '@/common/components/Breadcrumb'
import Hamburger from '@/common/components/Hamburger'
import ErrorLog from '@/common/components/ErrorLog'
// import Screenfull from '@/common/components/Screenfull'
import SizeSelect from '@/common/components/SizeSelect'
import LangSelect from '@/common/components/LangSelect'
import ThemePicker from '@/common/components/ThemePicker'
import { getUrlRootPath } from '@/common/utils/pathTools'
export default {
  name: 'GlobalHeader',
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    SizeSelect,
    LangSelect,
    ThemePicker
  },
  data() {
    return {
      dialogVisible: false,
      currentSelectKey: '',
      currentHospCode: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'userDisplayName',
      'loginUserInfo',
      'navMenus',
      'selectedFirstLLevelMenuitem',
      'notifyCount'
    ]),
    VersionInfo() {
      return this.$store.state.user.VersionInfo
    },
    navStyle() {
      return this.$store.state.app.nav_style
    },
    selectedMenuItemKey() {
      if (this.selectedFirstLLevelMenuitem) {
        return this.selectedFirstLLevelMenuitem.path
      } else {
        return ''
      }
    }
  },
  watch: {
    // 设置第一级导航菜单选择
    $route(to, from) {
      if (this.navStyle !== 'nonTopNav' && this.navStyle !== 'nonTopMenu') {
        const pathUrl = to.path
        this.updateSelectedMenuItem(pathUrl)
      }
    }
  },
  created() {
    if (this.navStyle !== 'nonTopNav' && this.navStyle !== 'nonTopMenu') {
      this.firstLevelMenuKeys = this.navMenus.map((item) => item.fullPath)
      this.updateSelectedMenuItem(this.$route.path)
    }
  },
  mounted() {},
  methods: {
    toHome() {
      this.$Confirm('离开此页面跳转至主页？', '提示', {
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          if (
            this.$route.path ==
            this.selectedFirstLLevelMenuitem.children[0].children[0].fullPath
          ) {
            return
          }
          this.$router.push(
            this.selectedFirstLLevelMenuitem.children[0].children[0].fullPath
          )
        })
        .catch(() => {})
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    onLogoutClick() {
      this.$Confirm('离开此网站？系统可能不会保存您所做的更改', '提示', {
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          this.$router.push('/')
          // 将用户信息清楚
          this.$store.commit('SET_LOGIN_USER_INFO', {})
          // const loginBackUrl = getUrlRootPath() + '#' + this.$route.fullPath
          // const callbackUrl = encodeURIComponent(loginBackUrl)
          // const logoutUrl =
          //   window.serverConfig.BASE_API + '/logout?callback=' + callbackUrl
          // window.location.href = logoutUrl
        })
        .catch(() => {})
    },
    onNavMenuitemClick(menuPath) {
      if (this.currentSelectKey !== menuPath) {
        this.$router.push(menuPath)
      }
    },
    getMeunMatcheys(menuKeys, path) {
      return menuKeys.filter((item) => {
        return pathToRegexp(item).test(path)
      })
    },
    updateSelectedMenuItem(pathUrl) {
      const urlList = urlToList(pathUrl)
      this.currentSelectKey = urlList
        .map((itemPath) =>
          this.getMeunMatcheys(this.firstLevelMenuKeys, itemPath).pop()
        )
        .filter((item) => item)[0]
      const selectMenuItem = this.navMenus.find(
        (item) => item.fullPath === this.currentSelectKey
      )
      this.$store.dispatch('changeSelectfirstLevelMenuItem', selectMenuItem)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  // position: fixed;
  top: 0;
  background: var(--COLOR-NORMAL) !important;
  height: 44px;
  width: 100%;
  line-height: 44px;
  z-index: 1001;
  color: #fff;
  border-radius: 0px !important;
  overflow: hidden;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .topbar-logo {
    display: block;
    height: 100%;
    width: 44px;
    font-size: 16px;
    text-align: center;
  }
  .topbar-left {
    float: left;
  }
  .iconLogo-v-help {
    width: 0;
    height: 100%;
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
  }
  .icon-logo {
    height: 32px;
    width: 32px;
    display: inline-block;
    vertical-align: middle;
    line-height: 32px;
  }
  .image-logo-title {
    height: 32px;
    width: 100px;
    display: inline-block;
    vertical-align: middle;
    line-height: 32px;
  }
  .topbar-logo-text {
    height: 100%;
    padding: 0 2px;
    margin-right: 1px;
    color: #fff;
  }
  .nav-menu {
    display: table;
    height: 100%;
    padding: 0;
    list-style-type: none;
    margin: 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    position: relative;
    font-size: 15px;
    &:focus {
      outline: none;
    }
    .nav-menu-item {
      display: table-cell;
      padding: 0 20px;
      margin: 0;
      outline: 0;
      height: 44px;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      white-space: nowrap;
      &:hover {
        outline: none;
        background-color: #106ebe;
        cursor: pointer;
      }
      .international-icon {
        width: 1.3em;
        height: 1.3em;
        vertical-align: -0.35em;
      }
      &.selected {
        background-color: #106ebe;
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          margin-left: calc(50% - 6px);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid #f4f4f4;
        }
      }
    }
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .topbar-right {
    float: right;
  }
  .right-menu {
    display: table;
    height: 100%;
    padding: 0;
    list-style-type: none;
    margin: 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    position: relative;
    font-size: 14px;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: table-cell;
      // padding: 0 10px;
      margin: 0;
      outline: 0;
      height: 44px;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      white-space: nowrap;
      &:hover {
        outline: none;
        background-color: #106ebe;
        cursor: pointer;
      }
      .international-icon {
        margin: 0 10px;
        width: 1.3em;
        height: 1.3em;
        vertical-align: -0.35em;
      }
    }
    .version {
      margin-right: 16px;
    }
    .right-menu-item2 {
      display: table-cell;
      transform: translateY(3px);
      margin: 0;
      outline: 0;
      height: 44px;
      width: 20px;
      position: relative;
      vertical-align: middle;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      &:hover {
        outline: none;
        background-color: #106ebe;
        cursor: pointer;
      }
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  .topbar-dept-select {
    height: 100%;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    position: relative;
    font-size: 14px;
    color: #eee;
    background-color: #005a9e;
    text-align: left;
    width: 140px;
    &:hover {
      outline: none;
      color: #fff;
      background-color: #014070;
      cursor: pointer;
    }
    > i {
      float: right;
      line-height: 44px;
    }
  }
  .topbar-dept-select-popover {
    list-style-type: none;
    margin: 2px 0;
    color: rgb(51, 51, 51);
    padding: 0;
    li {
      height: 38px;
      line-height: 38px;
      padding: 0px 10px;
      &:hover {
        outline: none;
        // color: #fff;
        background-color: #eff6fc;
        cursor: pointer;
      }
    }
  }
  .login-user-info {
    padding: 0 10px 0 0;
  }
}
.login-info-panel {
  color: black;
  padding: 10px;
  .info-title {
    display: inline-block;
    color: gray;
    width: 70px;
    text-align: right;
  }
  .logout-btn {
    padding: 10px 30px;
    margin-left: 50px;
  }
}
</style>
<style lang="scss">
.navbar {
  .el-badge__content.is-fixed {
    top: 8px;
    right: 20px;
  }
}
</style>
